import { ColyseusManager } from "../../../ColyseusManager";
import { GameVars } from "../../../GameVars";
import { BoardManager } from "./BoardManager";
import * as Carrom from "carrom-king-engine";

export class BoardManagerPVP extends BoardManager {

    constructor() {
        
        super();
    }

    protected onTurnCompleted(
        strikerPosition: Carrom.Vector2D, 
        pucks: Carrom.Puck [], 
        pocketedPucks: Carrom.Puck [], 
        alternatePlayer: boolean, 
        hasQueenBeenPocketed: boolean, 
        restituteQueen: boolean, 
        skipQueenCovering: boolean,
        score: number,
        hasPlayerWon: boolean,
        hasAdversaryWon: boolean,
        faults: string[]
        ): void {

        super.onTurnCompleted(
            strikerPosition, 
            pucks, 
            pocketedPucks, 
            alternatePlayer, 
            hasQueenBeenPocketed, 
            restituteQueen, 
            skipQueenCovering,
            score, 
            hasPlayerWon, 
            hasAdversaryWon,
            faults
        ); 

        if (GameVars.connection) {
            ColyseusManager.sendMessage("TURN COMPLETED", GameVars.turnData);
        } else {
            GameVars.needSendTurnData = true;
        }
    }
}
